module.exports = __webpack_public_path__ + "img/AI.jpg";